/* LPC header behaviour: the menu button and the search button each show/hide the panel named in their
   aria-controls. One panel is open at a time, Escape closes it, and growing past the menu breakpoint
   closes the menu. Delegated listeners, so the theme editor re-rendering the header needs nothing re-bound. */
(function () {
  if (window.lpcChromeLoaded) return;
  window.lpcChromeLoaded = true;

  var DESKTOP = window.matchMedia('(min-width: 1101px)');

  function toggles() {
    return document.querySelectorAll('[data-lpc-toggle]');
  }

  function panelFor(button) {
    var id = button.getAttribute('aria-controls');
    return id ? document.getElementById(id) : null;
  }

  function setOpen(button, open) {
    var panel = panelFor(button);
    if (!panel) return;

    button.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.hidden = !open;

    if (open) {
      var focusSelector = button.getAttribute('data-lpc-focus');
      var target = focusSelector ? panel.querySelector(focusSelector) : null;
      if (target) target.focus();
    } else {
      // Dawn's predictive search keeps its own open state; close it together with the panel.
      var search = panel.querySelector('predictive-search');
      if (search && typeof search.close === 'function') search.close();
    }
  }

  function closeOthers(except) {
    Array.prototype.forEach.call(toggles(), function (button) {
      if (button !== except && button.getAttribute('aria-expanded') === 'true') setOpen(button, false);
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest ? event.target.closest('[data-lpc-toggle]') : null;
    if (!button) return;

    var willOpen = button.getAttribute('aria-expanded') !== 'true';
    closeOthers(button);
    setOpen(button, willOpen);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    var openButton = document.querySelector('[data-lpc-toggle][aria-expanded="true"]');
    if (!openButton) return;

    var panel = panelFor(openButton);
    var focusWasInside = document.activeElement === openButton || (panel && panel.contains(document.activeElement));

    setOpen(openButton, false);
    if (focusWasInside) openButton.focus();
  });

  function onBreakpoint(event) {
    if (!event.matches) return;
    Array.prototype.forEach.call(toggles(), function (button) {
      if (button.hasAttribute('data-lpc-menu') && button.getAttribute('aria-expanded') === 'true') setOpen(button, false);
    });
  }

  if (DESKTOP.addEventListener) DESKTOP.addEventListener('change', onBreakpoint);
  else if (DESKTOP.addListener) DESKTOP.addListener(onBreakpoint);

  // Theme editor: the header was re-rendered, so Dawn's cart drawer must bind its click handler to the new cart link.
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    if (!section || !section.querySelector) return;
    if (!section.querySelector('[data-lpc-header]') && !(section.matches && section.matches('[data-lpc-header]'))) return;

    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.setHeaderCartIconAccessibility === 'function') drawer.setHeaderCartIconAccessibility();
  });

  // With a cart app (settings.cart_app) there is no <cart-drawer> to repaint the header count. paint() takes a
  // cart-icon-bubble section response; refresh() fetches one; active() says the app's script really is running.
  var latest = 0;

  function paintBubble(html) {
    var bubble = document.getElementById('cart-icon-bubble');
    var section = html && new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
    if (bubble && section) bubble.innerHTML = section.innerHTML;
  }

  function refreshBubble() {
    var mine = ++latest;
    fetch('/?sections=cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (sections) {
        if (sections && mine === latest) paintBubble(sections['cart-icon-bubble']);
      })
      .catch(function () {});
  }

  window.lpcCartBubble = {
    paint: paintBubble,
    refresh: refreshBubble,
    // Only the <super-cart> element proves the runtime loaded (#supercart and window.superCart exist without it).
    active: function () {
      return window.lpcCartApp === 'supercart' && !!(window.customElements && customElements.get('super-cart'));
    },
    // True once the drawer is on screen: the body has the app's open class, or the panel inside the app's shadow root
    // has a non-zero box that overlaps the viewport and is not transparent. A closed panel sits off screen with opacity
    // 0, so it does not count. A slow phone can show the panel before (or without) the body class, so either ends the wait.
    drawerSeen: function () {
      if (document.body.classList.contains('supercart-open')) return true;
      var host = document.querySelector('super-cart');
      var panel = host && host.shadowRoot && host.shadowRoot.querySelector('.supercart-panel');
      if (!panel) return false;
      var box = panel.getBoundingClientRect();
      if (box.width <= 0 || box.height <= 0 || box.right <= 0 || box.bottom <= 0) return false;
      if (box.left >= window.innerWidth || box.top >= window.innerHeight) return false;
      var drawer = panel.closest('.supercart-drawer') || panel;
      return parseFloat(window.getComputedStyle(drawer).opacity) > 0;
    },
    // After an add: if the drawer never opens (the app failed after loading), show the cart page rather than nothing.
    // A customer who opens and quickly closes it stays put, because any sighting of the drawer ends the wait. A slow
    // phone can take over 2.5 s to open it, so the wait is up to 6 s.
    expectOpen: function () {
      var waited = 0;
      var timer = setInterval(function () {
        waited += 100;
        if (window.lpcCartBubble.drawerSeen()) {
          clearInterval(timer);
        } else if (waited >= 6000) {
          clearInterval(timer);
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      }, 100);
    },
  };

  // Changes made inside the app (quantity, remove) go through its own requests: watch the network, not fetch.
  if (window.lpcCartApp === 'supercart') {
    var burst = null;
    if (typeof PerformanceObserver === 'function') {
      try {
        new PerformanceObserver(function (list) {
          var changed = list.getEntries().some(function (entry) {
            return /\/cart\/(add|change|update|clear)/i.test(entry.name);
          });
          if (!changed) return;
          clearTimeout(burst);
          burst = setTimeout(refreshBubble, 150);
        }).observe({ entryTypes: ['resource'] });
      } catch (e) {}
    }
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) refreshBubble();
    });
  }

  // SuperCart draws the cart in an open shadow root that page CSS cannot reach, so the cart skin (window.lpcCartCss)
  // is attached inside it: one <link data-lpc-cart>, put back if a re-render drops it. The first FAQ opens once, and a
  // data attribute on the host remembers that, so a customer who closes it keeps it closed. If the app never loads,
  // whenDefined never resolves and none of this runs; the drawer then simply shows SuperCart's own look.
  function skinCart(host, root) {
    if (!root.querySelector('link[data-lpc-cart]')) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = window.lpcCartCss;
      link.setAttribute('data-lpc-cart', '');
      root.appendChild(link);
    }

    var faq = root.querySelector('.supercart-faqs details');
    if (faq && !host.hasAttribute('data-lpc-faq-opened')) {
      host.setAttribute('data-lpc-faq-opened', '');
      faq.open = true;
    }

    // Payment icons: Shopify's own list for this shop, printed by theme.liquid into <template id="lpc-pay-icons">, so
    // they always match Settings > Payments. They replace the text chips of the Html block; if the template is missing
    // or empty the chips stay. The attribute makes it one fill per element, and a re-render that drops it fills again.
    var pay = root.querySelector('.lpc-pay');
    var icons = document.getElementById('lpc-pay-icons');
    if (pay && icons && icons.content && icons.content.querySelector('svg') && !pay.hasAttribute('data-lpc-icons')) {
      pay.setAttribute('data-lpc-icons', '');
      pay.textContent = '';
      pay.appendChild(icons.content.cloneNode(true));
    }

    // The app asks the CDN for 200px-wide photos, which are soft on a 2x or 3x phone. The line and rail photos are
    // asked for 480px instead. This runs on every re-render, so only a photo still on the 200 is touched. The selector
    // also matches "width=2000", which the pattern leaves alone: assigning the same src again still records a mutation,
    // and the observer below would call this forever, so a src is only written when it really changed.
    var photos = root.querySelectorAll('.super-image-wrap img[src*="width=200"], .upsell-link img[src*="width=200"]');
    for (var i = 0; i < photos.length; i++) {
      var src = photos[i].getAttribute('src');
      var next = src.replace(/([?&]width=)200(?=&|$)/, '$1480');
      if (next !== src) photos[i].src = next;
    }
  }

  if (window.lpcCartApp === 'supercart' && window.lpcCartCss && window.customElements && customElements.whenDefined) {
    customElements.whenDefined('super-cart').then(function () {
      if (!window.lpcCartBubble.active()) return;

      var watched = null;
      var finder = null;

      function bind() {
        var host = document.querySelector('super-cart');
        var root = host && host.shadowRoot;
        if (!root || root === watched) return;

        watched = root;
        skinCart(host, root);
        if (window.MutationObserver) {
          new MutationObserver(function () {
            skinCart(host, root);
          }).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });
        }
        if (finder) finder.disconnect();
      }

      bind();
      if (!watched && window.MutationObserver) {
        finder = new MutationObserver(bind);
        finder.observe(document.documentElement, { childList: true, subtree: true });
      }
    });
  }
})();
